import { render } from "./CarrierInformation.vue?vue&type=template&id=2160b57a&scoped=true"
import script from "./CarrierInformation.vue?vue&type=script&lang=js"
export * from "./CarrierInformation.vue?vue&type=script&lang=js"

import "./CarrierInformation.vue?vue&type=style&index=0&id=2160b57a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2160b57a"]])

export default __exports__